import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { activateColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getActivate } from "../../../../api/sim";

const COPY_KEYS = [
  "id",
  "batch_id",
  "iccid",
  "status",
  "msisdn",
  "extra_data.imei",
  "extra_data.name",
  "extra_data.address",
  "extra_data.email",
  "last_updated",
];

const CricketActivateBatch = () => (
  <BatchDetail
    title="Activate"
    apiGet={__getActivate}
    client={CLIENTS.cricket}
    columnsFactory={(ctx) =>
      activateColumns({ ...ctx, showAreacode: false, showZipcode: false, showTrialCount: true, showImei: true })
    }
    copyKeys={COPY_KEYS}
    exportAction="activate"
    showTerminate
    getRowPath={(row) => `/cricket/activate/${row.id}`}
  />
);

export default CricketActivateBatch;
